export default __webpack_public_path__ + "static/media/Group 3215@2x.472280a0.png";